import { InteractionButton } from "../../lib/ui/toolbar/buttons";
export class MeasureDistanceButton extends InteractionButton {
    constructor() {
        super('ruler', 'Measure Distance', 'lengthBtn');
        this.set_interaction('length');
    }
}
